module.exports = __webpack_public_path__ + "static/media/main-2.91bc4275.jpeg";